"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
//import nestedComponentForm from '../_classes/nested/NestedComponent.form';
const Components_1 = __importDefault(require("../../Components"));
const comfirm_edit_display_1 = __importDefault(require("./editForm/comfirm.edit.display"));
const comfirm_edit_api_1 = __importDefault(require("./editForm/comfirm.edit.api"));
const sdk_1 = require("@ariform/core/sdk");
/**
 *
 * @param {...any} extend
 */
function default_1(...extend) {
    return Components_1.default.baseEditForm([
        {
            key: 'display',
            components: comfirm_edit_display_1.default
        },
        {
            key: 'data',
            ignore: sdk_1.AriForm.isBPM,
        },
        {
            key: 'validation',
            ignore: sdk_1.AriForm.isBPM,
        },
        {
            key: 'api',
            components: comfirm_edit_api_1.default
        },
        {
            key: 'logic',
            ignore: sdk_1.AriForm.isBPM,
        },
        {
            key: 'layout',
            ignore: sdk_1.AriForm.isBPM,
        },
        {
            key: 'addons',
            ignore: sdk_1.AriForm.isBPM,
        },
        {
            key: 'conditional',
            ignore: sdk_1.AriForm.isBPM,
        },
    ], ...extend);
}
exports.default = default_1;
